<template>
  <div class="app-credit-card">
    <slot name="txtBefore"></slot>
    <b-embed v-if="pending"
      type="iframe"
      id="cnpIframe"
      :src="frameAddress"
      ></b-embed>
    <div v-if="completed">
      <ShowCreditCardInformation :credit-card-information="creditCardInformation_">
        <template #txtBefore><slot name="txtCcInfoBefore"></slot></template>
        <template #lblCcHolder><slot name="lblCcInfoCcHolder"></slot></template>
        <template #lblCcNumber><slot name="lblCcInfoCcNumber"></slot></template>
        <template #lblCcType><slot name="lblCcInfoCcType"></slot></template>
        <template #lblCcValidty><slot name="lblCcInfoCcValidty"></slot></template>
        <template #txtAfter><slot name="txtCcInfoAfter"></slot></template>
        <template #txtError><slot name="txtCcInfoError"></slot></template>
      </ShowCreditCardInformation>
    </div>
    <a @click.prevent="restart()" href="#"><slot name="btnCcRestart">Neu starten</slot></a>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ShowCreditCardInformation from './ShowCreditCardInformation.vue'
import syncProperty from '@/mixins/syncProperty'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'EnterCreditCardData',
  mounted () {
    const urlParameters = new URLSearchParams(window.location.search)
    const token = urlParameters.get('id')
    const resourcePath = urlParameters.get('resourcePath')
    if (token !== null && resourcePath !== null) {
      this.finishCCProcess(token)
    } else {
      if (this.pending === false && (this.creditCardInformation === null || this.creditCardInformation.registrationId === null)) {
        this.initialize()
      }
    }
    window.addEventListener('message', this.receiveMessage, false)
    window.addEventListener('oppwaError', this.onError, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.receiveMessage)
    window.removeEventListener('oppwaError', this.onError)
  },
  components: {
    ShowCreditCardInformation
  },
  computed: {
    ...mapGetters([
      'brand'
    ]),
    ...mapGetters('payment/creditCard', [
      'token',
      'step'
    ]),
    pending: function () {
      return this.step === 'pending'
    },
    completed: function () {
      return this.step === 'completed'
    },
    frameAddress: function () {
      return `${this.ccFrameAddress}?redirectUrl=${this.redirectUrl}&token=${this.token}`
    }
  },
  methods: {
    ...mapActions('payment/creditCard', [
      'initCreditCardPayment',
      'postProcessCreditCard'
    ]),
    ...mapMutations('payment/creditCard', [
      'markCreditCardCompleted',
      'restartProcess',
      'clearCreditCard'
    ]),
    async initialize () {
      this.creditCardInformation_ = null
      await this.initCreditCardPayment({
        personalData: this.personalData,
        processName: this.processName
      })
      this.clearCreditCard()
      this.$emit('start')
    },
    async finishCCProcess (token, stripUrl = true) {
      this.markCreditCardCompleted()
      if (stripUrl) {
        window.history.replaceState({}, document.title, window.location.pathname)
      }
      await this.postProcessCreditCard({ token: token, processName: this.processName })
      this.$emit('complete', this.creditCardInformation_)
    },
    restart () {
      this.restartProcess()
      this.initialize()
    },
    // iframe sends a message for async redirect if it cannot redirect itself. we
    // capture this and grab the data so we no not even need to redrect the user (win-win)
    receiveMessage (event) {
      const data = event.data
      const comp = this
      if (data.method === 'asyncRedirect' && data.params) {
        const param = data.params.find(item => item.name === 'id')
        if (param && param.value) {
          comp.finishCCProcess(param.value, false)
        }
      }
    },
    onError (error) {
      console.log(error)
    }
  },
  mixins: [
    syncProperty('creditCardInformation', 'creditCardInformation_')
  ],
  props: {
    ccFrameAddress: {
      type: String
    },
    redirectUrl: {
      type: String,
      default: function () {
        const loc = window.location
        return loc.origin + loc.pathname
      }
    },
    processName: {
      type: String,
      required
    },
    personalData: {
      type: Object,
      default: function () {
        return {
          firstName: 'Max',
          lastName: 'Mustermann',
          email: 'max.mustermann@example.org',
          address: {
            street: 'Carl-Schurz-Str.',
            houseNumber: '2',
            zip: '41460',
            city: 'Neuss'
          }
        }
      }
    }
  }
}
</script>
